
































import { Component, Vue, Prop } from 'vue-property-decorator';
// https://github.com/surmon-china/vue-awesome-swiper
// https://honneraku.com/post-376/
// https://qiita.com/github129/items/d8951c2a1371a310f07e
// Swiperを自力で頑張る http://insider.10bace.com/2019/02/06/vue-js%E3%81%A8swiper%E3%81%A8%E6%99%82%E3%80%85axios/
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import Swiper, { SwiperOptions } from 'swiper';
import JobOfferCard from '@/components/JobOfferCard.vue';
import { NSOffer } from '@/types/Offer';
import { pagePerItems } from '@/types/jobOffer';

@Component({
  components: {
    JobOfferCard,
    swiper,
    swiperSlide
  }
})
export default class JobOfferCarousel extends Vue {
  @Prop() private offers!: NSOffer.Offer[];

  swiperOptions: SwiperOptions = {
    autoplay: false,
    loop: false,
    // https://github.com/nolimits4web/swiper/issues/2331
    // https://garigaricode.com/swiper_multirow/
    spaceBetween: 20,
    allowTouchMove: false,
    // direction: 'horizontal',
    // slidesPerColumnFill: 'row',
    // slidesPerColumn: 3,
    // slidesPerView: 2,
    // slidesPerView: 6,
    // slidesPerGroup: 6,
    // slidesPerGroup: 2,
    // centerInsufficientSlides: true,
    // --------------------------------------------------
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    pagination: {
      el: '.pagination',
      type: 'bullets',
      bulletClass: 'page',
      clickable: true,

      renderBullet: function(index: number, className: string) {
        return '<span class="' + className + '">' + (index + 1) + '</span>';
      }
    },
    on: {
      slideChange: function() {
        const headerElement = document.getElementById('app-2');
        if (!headerElement) return;
        headerElement.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  created() {}

  mounted() {
    // console.log(this.swiper);
    this.swiper.on('slideChange', () => {
      /**
       * swiper.paginationコンポーネントのupdate内の返り値が手に入らないので自前
       */
      let index = this.swiper.activeIndex;

      const slidesPerView = this.swiper.params.slidesPerView as number;
      const slidesPerGroup = this.swiper.params.slidesPerGroup as number;
      const slidesPerColumn = this.swiper.params.slidesPerColumn as number;
      if (
        slidesPerGroup &&
        slidesPerView &&
        slidesPerColumn &&
        slidesPerGroup > 1
      ) {
        index = Math.ceil(index / slidesPerGroup);
      }

      this.$emit('slideChange', index);
    });
    //初期状態とスライドが変わったときに再度判定
    this.bulletsShowHandle();
    this.swiper.on('slideChange', () => {
      this.bulletsShowHandle();
    });
  }
  // 求人タイプが変わった時に作動
  updated() {
    this.bulletsShowHandle();
  }
  // paginationの表示数を制御
  bulletsShowHandle(): void {
    //ページネーションを取得
    const bullets = document.querySelectorAll('.page') as NodeListOf<
      HTMLElement
    >;
    // ページネーションが5個以内なら省略しない
    if (bullets.length <= 4) return;
    let current = this.swiper.activeIndex;
    // 上限,下限(...)を表示するタイミングを設定
    const showUpperLimit = current + 2;
    const showLowerLimit = current - 2;
    const pointClassName = '-point';
    bullets.forEach(function(el, index) {
      if (index == showUpperLimit || index == showLowerLimit) {
        el.classList.add(pointClassName);
        el.style.display = 'inline-block';
      } else if (index > showUpperLimit || index < showLowerLimit) {
        el.style.display = 'none';
      } else {
        el.style.display = 'inline-block';
        el.classList.remove(pointClassName);
      }
    });
  }

  /**
   * 1ページにpagePerItems件のデータを詰め込むための連想配列を作る
   */
  public get slides(): NSOffer.Offer[][] {
    const slides = [];
    const offerLength = this.offers.length;
    //日付順にソート
    this.offers.sort(function(a, b) {
      if (a.date > b.date) return -1;
      if (a.date < b.date) return 1;
      return 0;
    });
    //掲載終了求人を最後に移動
    this.offers.sort(function(a, b) {
      return a.recruitment === b.recruitment ? 0 : a.recruitment ? -1 : 1;
    });
    for (let i = 0; i < Math.ceil(offerLength / pagePerItems); i++) {
      const j = i * pagePerItems;
      const slide: NSOffer.Offer[] = this.offers.slice(j, j + pagePerItems);

      slides.push(slide);
    }

    return slides;
  }

  public get swiper(): Swiper {
    const instance = this.$refs.jobOfferCarousel as any;
    // if (instance.hasOwnProperty('swiper')) {
    return instance.swiper;
    // }
  }
}
